<script>
  import Header from './Header.svelte';
  import MobileMenu from './MobileMenu.svelte';
  import { isAdminUser } from '../../config.js';

  export let user = null;
  export let currentPage = 'home';
  export let onLogout = null; // App.svelte의 handleLogout 함수

  let isMenuOpen = false;
  let isDropdownOpen = false;
  let isApplicantMenuOpen = false;

  $: isAdmin = user ? isAdminUser(user) : false;
  $: isCompany = user?.role === 'company';
  
  function handlePageChange(page) {
    const event = new CustomEvent('pagechange', {
      detail: { page }
    });
    window.dispatchEvent(event);
  }
  
  function handleLogout() {
    if (onLogout) {
      onLogout();
    } else {
      // fallback: CustomEvent 사용
      const event = new CustomEvent('logout');
      window.dispatchEvent(event);
    }
  }
  
  function handleLogoClick() {
    const event = new CustomEvent('logoclick');
    window.dispatchEvent(event);
  }
  
  function toggleMenu() {
    isMenuOpen = !isMenuOpen;
  }
  
  function toggleDropdown() {
    isDropdownOpen = !isDropdownOpen;
  }
  
  function toggleApplicantMenu() {
    isApplicantMenuOpen = !isApplicantMenuOpen;
  }
  
  // 클릭 외부 영역 클릭 시 드롭다운 닫기
  function handleClickOutside(event) {
    if (!event.target.closest('.user-dropdown')) {
      isDropdownOpen = false;
    }
    if (!event.target.closest('.applicant-menu')) {
      isApplicantMenuOpen = false;
    }
  }
</script>

<svelte:window on:click={handleClickOutside} />

<Header 
  {user}
  {isAdmin}
  {isCompany}
  {currentPage}
  {isDropdownOpen}
  {isApplicantMenuOpen}
  onPageChange={handlePageChange}
  onLogout={handleLogout}
  onToggleDropdown={toggleDropdown}
  onToggleMenu={toggleMenu}
  onToggleApplicantMenu={toggleApplicantMenu}
  onLogoClick={handleLogoClick}
/>

<MobileMenu 
  {user}
  {isAdmin}
  {isCompany}
  {isMenuOpen}
  {currentPage}
  onPageChange={handlePageChange}
  onLogout={handleLogout}
  onToggleMenu={toggleMenu}
/>